var map = {
	"./AD.svg": "c9ef",
	"./AE.svg": "3800",
	"./AF.svg": "ee2e",
	"./AG.svg": "e8c4",
	"./AL.svg": "5d1c",
	"./AM.svg": "2185",
	"./AO.svg": "1c0a",
	"./AR.svg": "0e0a",
	"./AT.svg": "f8d7",
	"./AU.svg": "2974",
	"./AW.svg": "4f11",
	"./AZ.svg": "c9d5",
	"./BA.svg": "afc9",
	"./BB.svg": "f0a6",
	"./BD.svg": "1588",
	"./BE.svg": "9e93",
	"./BF.svg": "5870",
	"./BG.svg": "b920",
	"./BH.svg": "0001",
	"./BJ.svg": "f95a",
	"./BM.svg": "6470",
	"./BN.svg": "0748",
	"./BO.svg": "0d19",
	"./BR.svg": "ebed",
	"./BS.svg": "02af",
	"./BT.svg": "be22",
	"./BY.svg": "1449",
	"./CA.svg": "c102",
	"./CG.svg": "0205",
	"./CH.svg": "9391",
	"./CI.svg": "d8e3",
	"./CL.svg": "6415",
	"./CM.svg": "aded",
	"./CN.svg": "5805",
	"./CO.svg": "1aaf",
	"./CR.svg": "0a845",
	"./CU.svg": "173f",
	"./CV.svg": "2101",
	"./CW.svg": "615e",
	"./CY.svg": "fbd1",
	"./CZ.svg": "f41f",
	"./DE.svg": "2d8c",
	"./DJ.svg": "79b9",
	"./DK.svg": "aa18",
	"./DO.svg": "40bf",
	"./DZ.svg": "3742",
	"./EC.svg": "126f",
	"./EE.svg": "b9ff",
	"./EG.svg": "0307",
	"./ES.svg": "1304",
	"./ET.svg": "6baf",
	"./FI.svg": "4c03",
	"./FJ.svg": "ed49",
	"./FO.svg": "cfc1",
	"./FR.svg": "822f",
	"./GA.svg": "5d28",
	"./GB.svg": "7ba2",
	"./GE.svg": "2a49",
	"./GF.svg": "8cf8",
	"./GH.svg": "39a8",
	"./GI.svg": "e99d",
	"./GL.svg": "55e3",
	"./GM.svg": "630d",
	"./GN.svg": "d29d",
	"./GQ.svg": "c473",
	"./GR.svg": "c013",
	"./GT.svg": "0664",
	"./GU.svg": "2b2e",
	"./GY.svg": "fe34",
	"./HK.svg": "6574",
	"./HN.svg": "50ba",
	"./HR.svg": "08a6",
	"./HT.svg": "85dc",
	"./HU.svg": "d082",
	"./ID.svg": "f28c",
	"./IE.svg": "04b0",
	"./IM.svg": "6fc8",
	"./IN.svg": "5a2e",
	"./IQ.svg": "d614",
	"./IR.svg": "db82",
	"./IS.svg": "bee9",
	"./IT.svg": "a12e",
	"./JM.svg": "b2a6",
	"./JO.svg": "e109",
	"./JP.svg": "c359",
	"./KE.svg": "7f39",
	"./KG.svg": "825b",
	"./KH.svg": "8952",
	"./KR.svg": "2064",
	"./KW.svg": "493b",
	"./KY.svg": "4df0",
	"./KZ.svg": "a254",
	"./LB.svg": "a778",
	"./LC.svg": "63cb",
	"./LI.svg": "77f1",
	"./LK.svg": "1f92",
	"./LR.svg": "10cb",
	"./LT.svg": "9e55",
	"./LU.svg": "31ec",
	"./LV.svg": "31da",
	"./MA.svg": "8d46",
	"./MC.svg": "e413",
	"./MD.svg": "51f5",
	"./ME.svg": "5cc2",
	"./MF.svg": "42c7",
	"./MG.svg": "4e79",
	"./MK.svg": "b560",
	"./MN.svg": "45a4",
	"./MO.svg": "10b4",
	"./MR.svg": "5685",
	"./MT.svg": "34ca",
	"./MU.svg": "d002",
	"./MV.svg": "7fe3",
	"./MX.svg": "ef0d",
	"./MY.svg": "d503",
	"./NA.svg": "4b9c",
	"./NC.svg": "6f2d",
	"./NE.svg": "a181",
	"./NG.svg": "8e0a",
	"./NI.svg": "d97b",
	"./NL.svg": "ea1a",
	"./NO.svg": "08de",
	"./NP.svg": "71e1",
	"./NZ.svg": "3160",
	"./OM.svg": "52ce",
	"./PA.svg": "6e9a",
	"./PE.svg": "ec59",
	"./PF.svg": "0d2a",
	"./PG.svg": "4e42",
	"./PH.svg": "69a4",
	"./PK.svg": "5bca",
	"./PL.svg": "49b8",
	"./PR.svg": "861d1",
	"./PS.svg": "f485",
	"./PT.svg": "28ac",
	"./PY.svg": "8508",
	"./QA.svg": "4f4d",
	"./RO.svg": "c6ed",
	"./RU.svg": "4155",
	"./RW.svg": "050b",
	"./SA.svg": "9f9e",
	"./SC.svg": "2566",
	"./SD.svg": "5d23",
	"./SE.svg": "f208",
	"./SG.svg": "9c4b",
	"./SI.svg": "59f7",
	"./SK.svg": "3dc3",
	"./SM.svg": "d1db",
	"./SN.svg": "76e2",
	"./SO.svg": "d90b",
	"./SR.svg": "fa96",
	"./SV.svg": "f96d",
	"./SZ.svg": "ba1e",
	"./TD.svg": "3588",
	"./TG.svg": "8cdf",
	"./TH.svg": "898f",
	"./TN.svg": "b49a",
	"./TR.svg": "c955",
	"./TT.svg": "1f12",
	"./TW.svg": "5ea5",
	"./TZ.svg": "9640",
	"./UA.svg": "dda3",
	"./US.svg": "ac0e",
	"./UY.svg": "128e",
	"./UZ.svg": "4464",
	"./VC.svg": "4265",
	"./VE.svg": "c6ef",
	"./VI.svg": "4fed",
	"./VN.svg": "5b28",
	"./ZA.svg": "2d19",
	"./ZM.svg": "2e4f",
	"./ZW.svg": "f7cd",
	"./_logo.svg": "29da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7541";